import React, { useState } from "react";
import { Modal, Input, notification, Rate } from "antd";

const { TextArea } = Input;

const openNotification = () => {
  notification.success({
    message: "Success!",
    description: "Thank you for providing your feedback!!!",
    onClick: () => {
      console.log("Notification Clicked!");
    },
  });
};

const FeedbackForm = ({ visible, setVisible, onSave }) => {
  const [ratings, setRatings] = useState(0);
  const [comments, setComments] = useState("");
  const [buttonDisable, setButtonDisable] = useState(true);

  const handleSuccess = () => {
    setVisible(false);
    setRatings(0);
    setComments("");
    setButtonDisable(true);
    openNotification();
  };

  const handleFailure = () => {
    console.log("An error occured");
    setVisible(false);
    setRatings(0);
    setComments("");
    setButtonDisable(true);
  };

  const onSubmit = () => {
    const payloadData = {
      ratings,
    };
    if (comments.length > 0) payloadData.comments = comments;

    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };
    onSave(payload);
  };

  const handleCancel = () => {
    setRatings(0);
    setComments("");
    setButtonDisable(true);
    setVisible(false);
  };

  return (
    <Modal
      title="Provide Your Feedback"
      visible={visible}
      okText="Submit"
      okButtonProps={{ disabled: buttonDisable }}
      onOk={onSubmit}
      onCancel={handleCancel}
    >
      <p style={{ fontWeight: "500", fontSize: "14px" }}>
        Ratings:
        <Rate
          value={ratings}
          onChange={(val) => {
            setRatings(val);
            if (val > 0) setButtonDisable(false);
          }}
          style={{ fontSize: "20px", marginLeft: "5px" }}
        />
      </p>

      <p style={{ marginTop: "10px", fontWeight: "500", fontSize: "14px" }}>
        Comments:
      </p>
      <TextArea
        rows={4}
        value={comments}
        onChange={(e) => {
          setComments(e.target.value);
        }}
      />
    </Modal>
  );
};

export default FeedbackForm;
